import React, { useState } from "react";

const ProductInfo = ({ selectedProd, familyProd }) => {
  const kashrut = selectedProd.kosherSupervision?.[0]?.classification ?? "";

  return (
    <>
      <h4 className="prod-name">{selectedProd.name}</h4>
      <h5>{selectedProd.description}</h5>
      <div className="prod-info-line">
        {!familyProd && selectedProd.subBrand?.name && (
          <>
            <p className="prod-brand">{selectedProd.subBrand?.name}</p>
            <span className="line">|</span>
          </>
        )}

        {!familyProd && selectedProd.weightDetails && (
          <>
            <span className="prod-details">
              {selectedProd.weightDetails?.netContent}
            </span>
            <span>{selectedProd.weightDetails.unitOfMeasure}</span>
          </>
        )}

        {(kashrut === "בשרי" || kashrut === "חלבי" || kashrut === "פרווה") && (
          <>
            {!familyProd &&
              (selectedProd.weightDetails || selectedProd.subBrand?.name) && (
                <span className="line">|</span>
              )}
            <span
              className={
                kashrut === "בשרי"
                  ? "fleshy"
                  : kashrut === "חלבי"
                    ? "milky"
                    : "parve"
              }
            >
              {kashrut}
            </span>
          </>
        )}
      </div>
    </>
  );
};
export default ProductInfo;
